import React from 'react';

interface UserNameProps {
  userName?: string;
}

export const UserName: React.FC<UserNameProps> = ({ userName }) => {

  const prefixedName = userName ? `@${userName}` : '';

  return (
    <span className='text-app-gray'>{prefixedName}</span>
  );
};
